import {GET_GENERAL_DATA} from "../../../../enums/Profile/profile";

export const getGeneralDataAction = (data)=>{
    return{
        type:GET_GENERAL_DATA,
        payload:data,
    };
};
